import { useParams } from "react-router-dom"
import { Container, Row, Col, Button, Stack } from "react-bootstrap"
import { useDeleteKeyValueMutation, useGetKeyValueByIdQuery } from "../../../services/bClientApi"
import KeyValueEntry from "../../../Components/KeyValue/KeyValueEntry/KeyValueEntry"
import { navigateTo } from "../../../redux/router/routerActions"
import { useAppDispatch } from "../../../redux/store"

export default function DeleteKeyValuePage() {
    const { keyValueId = '' } = useParams()

    const {
        data: keyValueData,
        error,
        isLoading
    } = useGetKeyValueByIdQuery(keyValueId, { skip: !keyValueId })

    const [
        deleteKeyValue,
        {
            isLoading: deleteIsLoading,
            error: deleteError
        }
    ] = useDeleteKeyValueMutation()

    const dispatch = useAppDispatch()

    const handleDelete = async () => {
        try {
            await deleteKeyValue(keyValueId).unwrap()
            dispatch(navigateTo('/key-values'))
        } catch (err) {
            console.error('Failed to delete key value:', err)
        }
    }

    return (
        <Container>
            <Row>
                <Col>
                    <h1>Delete Key Value</h1>
                    <hr />
                    {error && (<>{JSON.stringify(error)}<br /></>)}
                    {deleteError && (<>{JSON.stringify(deleteError)}<br /></>)}

                    {keyValueId && keyValueData && !isLoading && (
                        <div className="key-value-info">
                            <div className="mb-4">
                                <h4>Key Value to Delete</h4>
                                <KeyValueEntry
                                    keyValueData={keyValueData}
                                    fullView={true}
                                    showActions={false}
                                />
                            </div>

                            <Stack gap={3}>
                                <div className="alert alert-warning">
                                    <strong>Warning!</strong> Are you sure you want to delete this key value? This action cannot be undone.
                                </div>
                                <div>
                                    <Button 
                                        variant="secondary" 
                                        className="me-2"
                                        onClick={() => dispatch(navigateTo(`/key-value/${keyValueId}`))}
                                    >
                                        Cancel
                                    </Button>
                                    <Button 
                                        variant="danger"
                                        onClick={handleDelete}
                                        disabled={deleteIsLoading}
                                    >
                                        {deleteIsLoading ? 'Deleting...' : 'Delete Key Value'}
                                    </Button>
                                </div>
                            </Stack>
                        </div>
                    )}
                </Col>
            </Row>
        </Container>
    )
}